import { createAction, props } from '@ngrx/store';

export const setFlagReminderMsg = createAction('[FlagReminderMsg] Set FlagReminderMsg', props<{ msg: string }>());
export const clearFlagReminderMsg = createAction('[FlagReminderMsg] Clear FlagReminderMsg');